<script setup>
defineProps({
    modelValue: {type: [Number, String], default: 0},
});

const emit = defineEmits(["update:modelValue", "input"]);
const updateValue = (value) => {
    if (value !== "") {
        emit("update:modelValue", value);
    }
    console.log(value);
}
</script>
<template>
   <span>
    <button
        class="cursor-pointer"
        @click="updateValue(modelValue > 0 ? modelValue - 1 : null)"
    >
      -
    </button>
    <input :value="modelValue" type="number" min="0" @input="updateValue($event.target.value)"/>
    <button
        class="cursor-pointer"
        @click="updateValue(modelValue + 1)"
    >
      +
    </button>
  </span>
</template>

<style scoped>
input {
    width: 40px;
    text-align: center;
    border-color: black
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
button {
    background-color: white;
}
</style>
